/**
 * Pure cost calculation for a session given its usage + model.
 *
 * Returns USD cost computed from MODEL_RATES. Zero side effects.
 *
 * SPDX-License-Identifier: BUSL-1.1
 */
import { MODEL_RATES } from './model-rates.js';
/**
 * Format a USD cost value as a human-readable string.
 *
 * - Costs >= $1  → "$X.XX"
 * - Costs <  $1  → "$0.XX"  (at least 2 decimal places)
 * - Costs =  $0  → "$0.00"
 */
export function formatCost(costUsd) {
    if (costUsd >= 1)
        return `$${costUsd.toFixed(2)}`;
    if (costUsd > 0)
        return `$${costUsd.toFixed(4)}`;
    return '$0.00';
}
/** Calculate cost in USD for a session's usage. */
export function calculateSessionCost(usage, stats, model) {
    const rates = MODEL_RATES[model];
    if (!rates)
        return 0;
    const M = 1_000_000;
    return ((usage.inputTokens / M) * rates.input +
        (usage.outputTokens / M) * rates.output +
        (usage.cacheCreation5mTokens / M) * rates.cacheWrite5m +
        (usage.cacheCreation1hTokens / M) * rates.cacheWrite1h +
        (usage.cacheReadTokens / M) * rates.cacheRead +
        (stats.activeSeconds / 3600) * rates.sessionRuntimePerHour +
        (usage.webSearchRequests ?? 0) * rates.webSearchPerRequest);
}
//# sourceMappingURL=calculate-cost.js.map